import { BLOG_CATEGORIES, BLOG_STATUSES } from '@/constants/blog';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Input, Select, Space } from 'antd';

const { Option } = Select;

interface BlogFiltersProps {
  searchText: string;
  selectedCategory: string | undefined;
  selectedStatus: string | undefined;
  onSearch: (value: string) => void;
  onCategoryFilter: (value: string | undefined) => void;
  onStatusFilter: (value: string | undefined) => void;
  onClearFilters: () => void;
}

export const BlogFilters = ({
  searchText,
  selectedCategory,
  selectedStatus,
  onSearch,
  onCategoryFilter,
  onStatusFilter,
  onClearFilters,
}: BlogFiltersProps) => {
  const hasActiveFilters = Boolean(searchText || selectedCategory || selectedStatus);

  return (
    <Card className="admin-card mb-6">
      <Space size="middle" wrap className="w-full">
        <Input
          placeholder="Search blog posts..."
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => onSearch(e.target.value)}
          style={{ width: 300 }}
          size="large"
          allowClear
        />

        <Select
          placeholder="Filter by category"
          value={selectedCategory}
          onChange={onCategoryFilter}
          style={{ width: 180 }}
          size="large"
          allowClear
        >
          {BLOG_CATEGORIES.map((category) => (
            <Option key={category.value} value={category.value}>
              {category.label}
            </Option>
          ))}
        </Select>

        <Select
          placeholder="Filter by status"
          value={selectedStatus}
          onChange={onStatusFilter}
          style={{ width: 180 }}
          size="large"
          allowClear
        >
          {BLOG_STATUSES.map((status) => (
            <Option key={status.value} value={status.value}>
              {status.label}
            </Option>
          ))}
        </Select>

        {hasActiveFilters && (
          <Button icon={<ClearOutlined />} onClick={onClearFilters} size="large">
            Clear Filters
          </Button>
        )}
      </Space>
    </Card>
  );
};

export default BlogFilters;
